import {TpaList} from "./TpaList";
import {TpaEdit} from "./TpaEdit";
import {TpaCreate} from "./TpaCreate";

export default {
    list: TpaList,
    create: TpaCreate,
    edit: TpaEdit
};
